// Fonte: UManutContas.pas — AtualizaPerfilExterior() ~linha 11681
// Fonte: UManutContas.dfm — btnEndExterior (20/02/2024:Rogerio - s60/i1604)
// Modal para editar DDI/Telefone/País/Endereço exterior vinculado ao Cliente_Joia
import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { buscarPerfilExteriorConta, salvarPerfilExteriorConta } from '~/Services/Service';

var ModalPerfilExterior = function(_ref) {
  var show = _ref.show;
  var ge = _ref.ge;
  var codigo = _ref.codigo;
  var onHide = _ref.onHide;

  var [loading, setLoading] = useState(false);
  var [salvando, setSalvando] = useState(false);
  var [form, setForm] = useState({ ddi: '', telefone: '', pais: '', endereco: '' });

  useEffect(function() {
    if (show && ge && codigo) {
      setLoading(true);
      buscarPerfilExteriorConta(ge, codigo)
        .then(function(resp) {
          if (resp && resp.codigo) {
            setForm({
              ddi: resp.ddi || '',
              telefone: resp.telefone || '',
              pais: resp.pais || '',
              endereco: resp.endereco || '',
            });
          } else {
            setForm({ ddi: '', telefone: '', pais: '', endereco: '' });
          }
        })
        .catch(function() {
          setForm({ ddi: '', telefone: '', pais: '', endereco: '' });
        })
        .finally(function() { setLoading(false); });
    }
  }, [show, ge, codigo]);

  var handleChange = function(e) {
    var name = e.target.name;
    var value = e.target.value;
    setForm(function(prev) {
      var next = Object.assign({}, prev);
      next[name] = value;
      return next;
    });
  };

  var handleSalvar = function() {
    setSalvando(true);
    salvarPerfilExteriorConta(ge, codigo, form)
      .then(function() {
        toast.success('Perfil Exterior salvo com sucesso!');
        onHide();
      })
      .catch(function() {
        toast.error('Erro ao salvar Perfil Exterior');
      })
      .finally(function() { setSalvando(false); });
  };

  var handleLimpar = function() {
    setForm({ ddi: '', telefone: '', pais: '', endereco: '' });
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Endereço Exterior</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-4"><Spinner animation="border" size="sm" /> Carregando...</div>
        ) : (
          <>
            <Row>
              <Col md={2} className="mb-3">
                <Form.Label className="small mb-1">DDI</Form.Label>
                <Form.Control
                  type="text" size="sm" name="ddi"
                  value={form.ddi} onChange={handleChange}
                  maxLength={4} placeholder="+55"
                />
              </Col>
              <Col md={4} className="mb-3">
                <Form.Label className="small mb-1">Telefone</Form.Label>
                <Form.Control
                  type="text" size="sm" name="telefone"
                  value={form.telefone} onChange={handleChange}
                  maxLength={20}
                />
              </Col>
              <Col md={6} className="mb-3">
                <Form.Label className="small mb-1">País</Form.Label>
                <Form.Control
                  type="text" size="sm" name="pais"
                  value={form.pais} onChange={handleChange}
                  maxLength={50}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12} className="mb-3">
                <Form.Label className="small mb-1">Endereço</Form.Label>
                <Form.Control
                  type="text" size="sm" name="endereco"
                  value={form.endereco} onChange={handleChange}
                  maxLength={100}
                />
              </Col>
            </Row>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" size="sm" onClick={handleLimpar} disabled={salvando}>
          Limpar
        </Button>
        <Button variant="secondary" size="sm" onClick={onHide} disabled={salvando}>
          Cancelar
        </Button>
        <Button variant="primary" size="sm" onClick={handleSalvar} disabled={salvando || loading}>
          {salvando ? <><Spinner animation="border" size="sm" /> Salvando...</> : 'Salvar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalPerfilExterior;
